module.exports = __webpack_public_path__ + "static/img/home6.879ac5e3.png";